<!--
	The crash-risk calculator renders separately via the
	`attributes.countermeasures` slot (see ../Countermeasures).
-->
<script lang="ts">
	import { attributesColumns as safeintersectionsAttrsCols } from '../columns';
	import { attributesColumns as crashesAttrsCols } from '#lib/apps/safesystem/context/columns.js';
	import { getAccuracyWarnings } from '../alertsAndWarnings';
	import { EIdentify, EPrioritize } from '../interfaces';
	import { ECrashes } from '#lib/apps/safesystem/context/interfaces.js';
	import FeatureAttributesPanel, {
		layerPatchColor
	} from '#lib/components/FeatureAttributesPanel.svelte';
	import LegendPatch from '#lib/components/LegendPatch.svelte';

	const columns = { ...crashesAttrsCols, ...safeintersectionsAttrsCols };
</script>

<FeatureAttributesPanel
	{columns}
	alerts={(systemId, attrs) =>
		systemId === EPrioritize.Prioritize || systemId === EIdentify.Identify
			? getAccuracyWarnings(attrs as Parameters<typeof getAccuracyWarnings>[0])
			: []}>
	{#snippet icon(feature, systemId)}
		{#if systemId === EPrioritize.Prioritize || systemId === EIdentify.Identify || systemId === ECrashes.CrashesCircle}
			<LegendPatch
				color={layerPatchColor(feature.layer)}
				shape={systemId === EPrioritize.Prioritize ? 'square' : 'round'} />
		{/if}
	{/snippet}
</FeatureAttributesPanel>
